import { render, staticRenderFns } from "./LinedTitle.vue?vue&type=template&id=54763620"
import script from "./LinedTitle.vue?vue&type=script&lang=js"
export * from "./LinedTitle.vue?vue&type=script&lang=js"
import style0 from "./LinedTitle.vue?vue&type=style&index=0&id=54763620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports